import { BusinessController, SettingsController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { OnboardingStageTwo } from '../../pages';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { appStore, useStores } from '../../stores';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import React, { useState } from 'react';

const OnboardingContainer = () => {
	const {
		businessStore,
	} = useStores();
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const validationSchema = translations =>
		yup.object({
			bvn: yup.string().required('Please enter your BVN'),
			mobile: yup.string().required('Please enter your Phone number'),
			fullname: yup
				.string()
				.required('Full Name is required')
				.test('fullName', 'First and Last name is required', function (value) {
					const names = value ? value.split(' ') : [];
					return names.length > 1 && names[0].length > 1 && names[1].length > 1;
				}),
		});

	const switchToDasboard = () => {
		navigate(constant.Routes.AppHome);
	};

	const onSubmit = async values => {
		setLoading(true);
		const params = businessStore.OnboardingStageOne;
		const fdata = new FormData();
		fdata.append('businessAddress', params.address);
		fdata.append('businessCategory', params.bizIndustry);
		fdata.append('businessMobile', params.businessMobile);
		fdata.append('mobile', values.mobile);
		const names = values.fullname.split(' ');
		fdata.append('firstname', names[0]);
		fdata.append('lastname', names.length > 2 ? names[2]: names[1]);
		fdata.append('middlename', names.length > 2 ? names[1]: '');
		// params.instagram && fdata.append('instagramHandle', params.instagram);
		// params.webAddress && fdata.append('website', params.webAddress);
		params.logo && fdata.append('logo', params.logo);
		values.regNo && fdata.append('businessRegNum', values.regNo);
		fdata.append('bvn', values.bvn);
		const { status, errorMessage } = await BusinessController.update(fdata);

		if (status === constant.Success) {
			localStorage.setItem(
				constant.RouteParams,
				JSON.stringify({
					OtpType: constant.OtpType.BVNONBOARDING
				})
			);
			setLoading(false);
			return navigate(constant.Routes.Otp);
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<div>
			<OnboardingStageTwo
				validationSchema={validationSchema}
				onSubmit={onSubmit}
				loading={loading}
				switchToDasboard={switchToDasboard}
			/>
		</div>
	);
};

export default observer(OnboardingContainer);
